var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.4,
    height: 61.28,
    viewBox: "0 0 53.4 61.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.33,54.82H5.06c-1.45,0-2.84-.63-3.8-1.72-.96-1.09-1.41-2.55-1.22-3.99l2.67-21.22c.33-2.53,2.49-4.43,5.03-4.43h3.53c.41,0,.75.34.75.75s-.34.75-.75.75h-3.53c-1.79,0-3.31,1.34-3.55,3.12l-2.67,21.22c-.13,1.02.18,2.04.86,2.81.68.77,1.65,1.21,2.67,1.21h43.27c1.02,0,2-.44,2.68-1.21.68-.77.99-1.79.86-2.8l-2.67-21.22c-.23-1.77-1.76-3.11-3.55-3.11h-3.51c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h3.51c2.54,0,4.7,1.9,5.03,4.42l2.67,21.23c.19,1.44-.26,2.89-1.22,3.98-.96,1.1-2.35,1.72-3.8,1.72Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.39,48.15H1.01c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h51.37c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.34,39.89H2.06c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h49.28c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.86,32.61H2.98c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h14.89c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.43,32.61h-14.89c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h14.89c.41,0,.75.34.75.75s-.34.75-.75.75Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.46,48.15s-.03,0-.05,0c-.41-.03-.73-.38-.7-.79l.95-15.22c.03-.41.38-.73.8-.7.41.03.73.38.7.8l-.95,15.22c-.02.4-.36.7-.75.7Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.93,48.15c-.39,0-.72-.31-.75-.7l-.95-15.21c-.03-.41.29-.77.7-.8.41-.02.77.29.8.7l.95,15.21c.03.41-.29.77-.7.79-.02,0-.03,0-.05,0Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.71,61.28h-10.02c-2.25,0-4.08-1.83-4.08-4.08v-3.14c0-.41.34-.75.75-.75s.75.34.75.75v3.14c0,1.42,1.16,2.58,2.58,2.58h10.02c1.42,0,2.58-1.16,2.58-2.58v-3.14c0-.41.34-.75.75-.75s.75.34.75.75v3.14c0,2.25-1.83,4.08-4.08,4.08Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.55,25.69c-.1,0-.21-.02-.31-.07l-3.75-1.72c-1.83-.84-3.23-2.34-3.93-4.23-.7-1.89-.63-3.94.21-5.77.08-.18.23-.32.42-.39.19-.07.39-.06.57.02l3.74,1.71c1.49.67,2.69,1.78,3.46,3.21.2.36.07.82-.3,1.02-.36.2-.82.06-1.02-.3-.62-1.14-1.58-2.02-2.77-2.56l-3.02-1.38c-.41,1.28-.37,2.65.1,3.92.56,1.51,1.68,2.71,3.15,3.38l3.75,1.72c.38.17.54.62.37.99-.13.28-.4.44-.68.44Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.56,25.7c-.3,0-.59-.19-.7-.49-.99-2.65-.89-5.54.29-8.11,1.18-2.58,3.29-4.54,5.94-5.54l5.6-2.09c.19-.07.39-.06.57.02.18.08.32.23.39.42,2.05,5.48-.75,11.6-6.23,13.65l-5.6,2.09c-.09.03-.18.05-.26.05Zm10.92-14.55l-4.87,1.82c-2.28.85-4.09,2.54-5.1,4.75-.91,1.98-1.07,4.18-.48,6.25l4.87-1.82c4.47-1.67,6.86-6.5,5.58-11.01Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.7,35.11c-9.68,0-17.56-7.88-17.56-17.56S17.02,0,26.7,0s17.56,7.88,17.56,17.56-7.88,17.56-17.56,17.56Zm0-33.61c-8.85,0-16.06,7.2-16.06,16.06s7.2,16.06,16.06,16.06,16.06-7.2,16.06-16.06S35.55,1.5,26.7,1.5Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.4525fa2b61f373e0eef6021052d34a1f.svg";
export { ForwardRef as ReactComponent };